import React from 'react';

import Button from 'components/button/Button';
import { useModal } from 'context/ModalContext';

const ResetStep2 = () => {
  const { openModal, MODAL_TYPES } = useModal();

  const handleLogin = () => {
    openModal(MODAL_TYPES.LOGIN);
  };

  return (
    <div className="flex w-[309px] max-w-full flex-col items-center gap-y-5 px-5 py-6 md:mx-30 md:my-10 md:gap-y-6.25 md:p-0">
      <div className="flex w-full flex-col items-center gap-y-1.25">
        <img src="/images/optimized/illusts/il_check.webp" alt="reset" className="h-[54px] w-[54px] object-cover" />

        <h1 className="text-t4">Reset Password</h1>
        <p className="text-center text-c2 text-gray-40">
          Your new password has been successfully set.
          <br />
          Click the button below to log in.
        </p>
      </div>
      <Button text="Log in" shape="SQUARE" onClick={handleLogin} />
    </div>
  );
};

export default ResetStep2;
